<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>FACILITY<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="facilitys" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="facilityColumns" [selectionField]="'Facility_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addFacility($event)" (editEntity)="editFacility($event)"
            (refreshEntities)="refreshFacility($event)" (deleteEntity)="deleteFacility($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">  
        <div class="row sub-head"> 
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearFacility()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div> 
        </div>
        
        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Facility Name'" [mandatory]="true" [maxlength]="100" [formData]="entity"
                [fieldName]="'FacilityName'"  [(ngModel)]="entity.FacilityName" ngDefaultControl></textbox>
         </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Description'" [mandatory]="false" [multiline]="true" [formData]="entity"
                            [maxlength]="500" [fieldName]="'Description'" [(ngModel)]="entity.Description"
                            ngDefaultControl>
                        </textbox>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Unit'" [mandatory]="true" [maxlength]="2" [formData]="entity"
                            [fieldName]="'Unit'" (keypress)="numberOnly($event)" [(ngModel)]="entity.Unit"
                            ngDefaultControl></textbox>
                </div>
            </div>
          -->
            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="'Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'"
                        [type]="'button'" title="Back Tab"></btn>
                </div>
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
            </div> -->
        </div>
       
    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="Facility Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
        <div class="col-md-4 br-table-data">
            <label for="FacilityName" class="label label-1">Facility Name : </label> {{details.FacilityName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Description" class="label label-1">Description : </label> {{details.Description }}
          </div>
        </div>
        </div>
    </kendo-dialog>
<kendo-excelexport [data]="facilitys.data" [collapsible]="true" fileName="Facility.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="SlNo" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="FacilityName" title="Facility Name" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="Description" title="Description" [width]="200">
    </kendo-excelexport-column>     
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column> 
</kendo-excelexport>